import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

function AddSummaryBook() {
    const [book, setBook] = useState({
        title: '',
        author: '',
        categories: [],
        image_url: '',
        cefrLevel: 'A1'
    });

    const categoriesList = [
        'Fiction', 'Non-Fiction', 'Fantasy', 'Science Fiction',
        'Mystery', 'Thriller', 'Romance', 'Biography',
        'History', 'Children', 'Young Adult', 'Poetry',
        'Drama', 'Adventure', 'Horror', 'Self-Help',
        'Business', 'Science', 'Philosophy', 'Religion','Psychology'
    ];

    const cefrLevels = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

    const handleChange = (e) => {
        setBook({ ...book, [e.target.name]: e.target.value });
    };

    const handleCategoriesChange = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
        setBook({ ...book, categories: selectedOptions });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/summary-book`, book);
            if (response.data.success) {
                toast.success('Summary book added successfully!');
                setBook({
                    title: '',
                    author: '',
                    categories: [],
                    image_url: '',
                    cefrLevel: 'A1'
                });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Error adding summary book:", error);
            toast.error('Failed to add summary book');
        }
    };

    return (
        <>
            <Navbar />
            <div className="container mt-5 mb-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card shadow">
                            <div className="card-header bg-success text-white">
                                <h3 className="mb-0">Add New Summary Book</h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Title *</label>
                                        <input type="text" className="form-control" name="title" value={book.title} onChange={handleChange} required />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Author *</label>
                                        <input type="text" className="form-control" name="author" value={book.author} onChange={handleChange} required />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Categories (Select multiple)</label>
                                        <select className="form-select" name="categories" multiple size="5" value={book.categories} onChange={handleCategoriesChange}>
                                            {categoriesList.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                                        </select>
                                        <small className="text-muted">Hold Ctrl (Windows) or Cmd (Mac) to select multiple</small>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Image URL</label>
                                        <input type="text" className="form-control" name="image_url" value={book.image_url} onChange={handleChange} placeholder="https://example.com/book-cover.jpg" />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">CEFR Level</label>
                                        <select className="form-select" name="cefrLevel" value={book.cefrLevel} onChange={handleChange}>
                                            {cefrLevels.map(level => <option key={level} value={level}>{level}</option>)}
                                        </select>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <button type="submit" className="btn btn-success">Add Summary Book</button>
                                        <button type="button" className="btn btn-secondary" onClick={() => window.location.href = '/summary-books'}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AddSummaryBook;